import { css, html, LitElement } from 'lit'
import { property } from 'lit/decorators.js'
import { safeCustomElement } from '@/utilities/custom-element'
@safeCustomElement('mdc-header-mobile')
export class MdcHeaderMobile extends LitElement {
  @property({ type: Boolean, attribute: 'is-menu-open' }) isMenuOpen = false
  @property({ type: Boolean, attribute: 'is-avatar-open' }) isAvatarOpen = false

  static styles = css`
		:host {
			display: block;
			font-family: var(--typography-font-family-sans);
		}

		.mdc-header-mobile__main {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0.625rem 1rem;
		}

		.mdc-header-mobile__left {
			display: flex;
			align-items: center;
			flex-grow: 1;
		}

		.mdc-header-mobile__hamburger,
		.mdc-header-mobile__close {
			background-color: transparent;
			border: none;
			padding-left: 0;
			cursor: pointer;
			font-size: 1.5rem;
			line-height: 1;
		}

		.mdc-header-mobile__close {
			display: none;
		}

		.mdc-header-mobile__avatar-dropdown .mdc-header-dropdown {
			border: none;
		}

		.mdc-header-mobile--open-menu .mdc-header-mobile__menu-dropdown {
			grid-template-rows: 1fr;
		}

		.mdc-header-mobile--open-menu .mdc-header-mobile-menu {
			overflow-y: auto;
		}

		.mdc-header-mobile--open-menu .mdc-header-mobile__hamburger {
			display: none;
		}

		.mdc-header-mobile--open-menu .mdc-header-mobile__close {
			display: block;
		}

		.mdc-header-mobile--open-menu .mdc-header-mobile__search {
			display: none;
		}

		.mdc-header-mobile__menu-dropdown {
			display: grid;
			grid-template-rows: 0fr;
			transition: grid-template-rows 0.3s;
		}

		.mdc-header-mobile-menu {
			overflow: hidden;
		}

		.mdc-header-mobile--open-avatar .mdc-header-mobile__avatar-dropdown {
			grid-template-rows: 1fr;
		}

		.mdc-header-mobile--open-avatar .mdc-header-mobile__search {
			display: none;
		}

		.mdc-header-mobile--open-avatar .mdc-header-dropdown {
			border: 1px solid var(--color-functional-gray-200, #e5e5e5);
		}

		.mdc-header-mobile__avatar-dropdown {
			display: grid;
			grid-template-rows: 0fr;
			transition: grid-template-rows 0.3s;
		}
	`

  private handleMenuToggle() {
    this.isMenuOpen = !this.isMenuOpen
    this.dispatchEvent(
      new CustomEvent('menu-toggle', {
        detail: { isOpen: this.isMenuOpen },
        bubbles: true,
        composed: true,
      })
    )
  }

  private handleAvatarToggle() {
    this.isAvatarOpen = !this.isAvatarOpen
    this.dispatchEvent(
      new CustomEvent('avatar-toggle', {
        detail: { isOpen: this.isAvatarOpen },
        bubbles: true,
        composed: true,
      })
    )
  }

  render() {
    const containerClasses = `mdc-header-mobile${this.isMenuOpen ? ' mdc-header-mobile--open-menu' : ''}${this.isAvatarOpen ? ' mdc-header-mobile--open-avatar' : ''}`

    return html`
			<div class=${containerClasses}>
				<div class="mdc-header-mobile__main">
					<div class="mdc-header-mobile__left">
						<button
							type="button"
							class="mdc-header-mobile__hamburger"
							@click=${this.handleMenuToggle}
							aria-label="Open menu"
							aria-expanded=${this.isMenuOpen}
							aria-haspopup="true"
						>
							☰
						</button>
						<button
							type="button"
							class="mdc-header-mobile__close"
							@click=${this.handleMenuToggle}
							aria-label="Close menu"
							aria-expanded=${this.isMenuOpen}
							aria-haspopup="true"
						>
							✕
						</button>
						<slot name="logo"></slot>
					</div>
					<div class="mdc-header-mobile__search"><slot name="search"></slot></div>
					<button
						type="button"
						@click=${this.handleAvatarToggle}
						class="mdc-header-mobile__avatar-button"
						aria-label="User menu"
						aria-expanded=${this.isAvatarOpen}
						aria-haspopup="true"
					>
						<slot name="avatar"></slot>
					</button>
				</div>

				<div class="mdc-header-mobile__menu-dropdown">
					<div class="mdc-header-mobile-menu"><slot name="menu-content"></slot></div>
				</div>

				<div class="mdc-header-mobile__avatar-dropdown"><slot name="avatar-dropdown-content"></slot></div>
			</div>
		`
  }
}
